import React from 'react'
import PropTypes from 'prop-types'

const Alert = props => {
  return (
    <div className="alert-container">
      <div className={`alert alert-${props.bootstrapClass}`}>
        {props.message}
        {props.onDismiss ? (
          <button className="close" onClick={props.onDismiss} type="button">
            <span>&times;</span>
          </button>
        ) : null}
      </div>
    </div>
  )
}

Alert.propTypes = {
  bootstrapClass: PropTypes.string,
  message: PropTypes.string,
  onDismiss: PropTypes.func,
}

export default Alert
